export interface SplitAmount {
  integer: string;
  decimals: string;
}

export const splitAmount = (amount: number): SplitAmount => {
  const [intPart = '0', decPart = '00'] = amount.toFixed(2).split('.');
  const withThousandsSeparator = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
  return { integer: withThousandsSeparator, decimals: decPart };
};
